import classNames from "classnames";

function IntroText({ className }) {
  return (
    <div className={classNames("flex flex-col text-white", className)}>
      <span className="ps-intro-text-small">Hi!</span>
      <span className="ps-intro-text-large">
        I'm{" "}
        <span className="font-black text-red">
          <span className="pl-intro-r-shadow">R</span>ohan
        </span>
        .
      </span>
      <span className="ps-intro-text-small">I develop software.</span>
    </div>
  );
}

export default IntroText;
